module.exports = __webpack_public_path__ + "img/logo-headline65x400.a3f5f96d.png";